import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';
import React from 'react';
import PageToolbar from 'components/PageToolbar';
import { IconButton } from 'components/buttons';
import { CloseIcon } from 'components/icons';
import { dropdownSideSpacing } from 'styles/spacings';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
`;

export const LoaderContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;
	height: 100%;
	width: 100%;
`;

export const TableContainer = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	${({ isVisible }) => !isVisible && 'position: absolute; top: 100%;'};

	.ag-theme-balham {
		width: 100% !important;
	}
`;

export const CustomFiltersPageToolbar = styled(PageToolbar)`
	min-height: auto;
`;

export const CloseButton = styled(IconButton).attrs({
	children: <CloseIcon width={18} height={18} />,
})`
	padding: 0px ${dropdownSideSpacing};
	position: absolute;
	top: -34px;
	right: 0;
`;

export const Container = styled.div`
	width: 100%;
	overflow-y: auto;
	height: 100%;
	border-top: 1px solid ${colors.grey3};
`;

export const ScrollableContainer = styled.div`
	min-height: 500px;
	height: 700px;
`;

export const GridRow = styled.div`
	height: 150px;
	border: 1px solid ${colors.grey2};
`;
